import { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { DividersAndCardBorders } from '../../theme/colors';
import { RegularCardShadow } from '../../theme/shadows';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      boxShadow: RegularCardShadow,
      position: 'relative', // needed to position child elements that have absolute position,
      border: `1px solid ${DividersAndCardBorders}`,
      borderRadius: theme.shape.borderRadius,
    },
  }),
);

export const RegularCardBox: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  const classes = useStyles();

  return (
    <div {...props} className={clsx(classes.root, props.className)}>
      {children}
    </div>
  );
};
